import React from 'react';
import ServiceListItem from '../ServiceListItem';
import JsxHelper from '../../Helpers/JsxHelper';
import LookupText from '../../Elements/LookupText';
import LookupTextLookupItemIdArray from '../../Elements/LookupTextLookupItemIdArray';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import ShowNameComponent from '../../Elements/ShowNameComponent';
import CurrencyService from '../../Services/CurrencyService';

export default class OtherServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'Fieldwork',
      tabLabel: 'Fieldwork',
      icon: 'fa-solid fa-briefcase',
      data: [
        { name: (item) => JsxHelper.YesNo(item.InteractionRequired), label: 'Is Interaction Required?' },
        { name: (item) => Array.isArray(item.ViaEmailChatBotOrOther) ? item.ViaEmailChatBotOrOther.join(', ') : (item.ViaEmailChatBotOrOther || ''), label: 'Via Email, Chat Bot, or Other?' },
        { name: 'ProductOrServiceInquiry', label: 'Product or Service Inquiry?' },
        { name: 'TimeConstraints', label: 'Visit Time Constraints (days/hours/etc)' },
        { name: (item) => dateTimeHelper.convertMinutesToDate(item.EvaluationDuration * 60), label: 'Evaluation Duration' },
        { name: 'EstimatedTimePerAudit', label: 'Estimated Time per Audit (in minutes)' },
        { name: 'ChecklistDetails', label: 'Checklist Details' },
        { name: 'AuditSchedule', label: 'Audit Schedule' },
        { name: (item) => <LookupText lookupId={37} value={item.MaxDeliveryAfterShop} />, label: 'Time to Deliver Evaluation to Client' },
        { name: (item) => <LookupText lookupId={36} value={item.EvaluatorRotation} />, label: 'Evaluator Rotation' },
        { name: 'OperationalScope', label: 'Operational Scope' },
        { name: 'UserRoles', label: 'User Roles' },
        { name: (item) => JsxHelper.YesNo(item.LocationsDeliveredByClient), label: 'Locations Delivered by Client' },
        { name: (item) => Array.isArray(item.SpecialLocations) ? item.SpecialLocations.join(', ') : (item.SpecialLocations || ''), label: 'Special Locations' },
        { name: (item) => Array.isArray(item.LocationType) ? item.LocationType.join(', ') : (item.LocationType || ''), label: 'Location Type' },
        { name: 'LocationTypeDetails', label: 'Location Type Details', width: TabListTableCellWidthEnum.TwoLines },
        { name: (item) => JsxHelper.YesNo(item.LocationListProvided), label: 'Location List Provided' },
        { name: 'LocationListSource', label: 'Location List Source' },
        { name: (item) => Array.isArray(item.TypeOfStores) ? item.TypeOfStores.join(', ') : (item.TypeOfStores || ''), label: 'Type of Stores' },
        { name: 'AnnouncedOrUnannounced', label: 'Announced or Unannounced?' },
        { name: (item) => JsxHelper.YesNo(item.LetterOfAuthorizationRequired), label: 'Letter of Authorization Required?' },
        { name: (item) => <LookupText lookupId={21} value={item.DataCaptureMethodCode} />, label: 'Data Capture Method' },
        { name: 'OtherDataCaptureMethod', label: 'Other Data Capture Method Description' },
        { name: (item) => JsxHelper.YesNo(item.PhotosReqd), label: 'Photos Required?' },
        { name: 'PhotosDescription', label: 'Please Describe Photos Needed' },
        { name: (item) => Array.isArray(item.Tools) ? item.Tools.join(', ') : (item.Tools || ''), label: 'Tools' },
        { name: 'DataPoints', label: 'Data Points' },
        { name: (item) => JsxHelper.YesNo(item.CallingAheadRequired), label: 'Calling Ahead of Audit Required?' },
      ],
    },
    {
      tabName: 'ProgramApproach',
      tabLabel: 'Program Approach',
      icon: 'fa-solid fa-diagram-project',
      data: [
        { name: (item) => Array.isArray(item.InStoreOrOnline) ? item.InStoreOrOnline.join(', ') : (item.InStoreOrOnline || ''), label: 'In Store or Online' },
        { name: 'NumLocations', label: 'Number of Locations' },
        { name: 'NumItemsPricesPerLocation', label: 'Number of Items/Prices per Location?' },
        { name: 'NumDaysInField', label: 'Number of Days in Field?' },
        { name: (item) => Array.isArray(item.B2borB2c) ? item.B2borB2c.join(', ') : (item.B2borB2c || ''), label: 'B2B or B2C?' },
        { name: 'Objective', label: 'Objective' },
        { name: 'Frequency', label: 'Frequency' },
        { name: 'Coverage', label: 'Coverage' },
        { name: (item) => Array.isArray(item.PricingAspectsToEvaluate) ? item.PricingAspectsToEvaluate.join(', ') : (item.PricingAspectsToEvaluate || ''), label: 'What Pricing Aspects Should be Evaluated?' },
        { name: 'ProductType', label: 'Product Type' },
        { name: (item) => Array.isArray(item.DirectedPricingApproach) ? item.DirectedPricingApproach.join(', ') : (item.DirectedPricingApproach || ''), label: 'Directed Price Gathering Approach' },
        { name: 'DirectedPricingApproachDetails', label: 'Other Directed Pricing Approach Details', width: TabListTableCellWidthEnum.TwoLines },
        { name: (item) => JsxHelper.YesNo(item.DescriptionGatheringRequired), label: 'Description Gathering Required?' },
        { name: (item) => Array.isArray(item.KpisBehaviorRequirements) ? item.KpisBehaviorRequirements.join(', ') : (item.KpisBehaviorRequirements || ''), label: "Any Specific KPI's or Behavior Requirement?" },
        { name: (item) => JsxHelper.YesNo(item.PriceAccuracySlarequired), label: 'Price Accuracy SLA Required?' },
        { name: 'PriceAccuracySladescription', label: 'If yes, please describe' },
        { name: (item) => JsxHelper.YesNo(item.CompetitorPricingStudy), label: 'Competitor Pricing Study?' },
        { name: 'NumCompetitors', label: 'If yes, number of competitors' },
        { name: (item) => JsxHelper.YesNo(item.UpcjanianscanRequired), label: 'UPC/JAN/IAN Scan Required?' },
        { name: (item) => Array.isArray(item.DistributionOfSurvey) ? item.DistributionOfSurvey.join(', ') : (item.DistributionOfSurvey || ''), label: 'Distribution of Survey' },
        { name: 'BareOrClientSend', label: 'Does BARE Send or Does the Client Send?' },
        { name: 'SmsorEmailForBare', label: 'If BARE Sends, SMS or Email?' },
        { name: 'FrequencyOfSurvey', label: 'Frequency of Survey?' },
        { name: 'TargetNumResponses', label: 'Target Number of Responses?' },
        { name: 'TargetAudience', label: 'Target Audience (Location, Gender, Age, Profession, Income, Other)' },
        { name: 'IncentivesDescription', label: 'Incentives (please describe)?' },
        { name: 'DurationOfSurvey', label: 'Duration of Survey' },
        { name: 'PreferredTimeline', label: 'Preferred Timeline' },
        { name: 'BareBrandedOrCompanyBranded', label: 'Bare Branded or Company Branded?' },
        { name: (item) => JsxHelper.YesNo(item.EmployeesEnterName), label: 'Do Employees Enter Their Name?' },
        { name: (item) => Array.isArray(item.ReportingRequirements) ? item.ReportingRequirements.join(', ') : (item.ReportingRequirements || ''), label: 'Reporting Requirements' },
        { name: 'NumResponsesRequested', label: 'Number of Responses Requested' },
        { name: 'NumInterviewersPerLocation', label: 'Number of Interviewers per Location' },
        { name: 'LengthOfSurvey', label: 'Length of Survey' },
        { name: 'TabletOrPaper', label: 'Tablet or Paper?' },
        { name: 'InLocationOrEntrance', label: 'In the Location/Store or Entrance?' },
        { name: (item) => JsxHelper.YesNo(item.AuthorizationLetterProvided), label: 'Authorization Letter Provided?' },
        { name: 'IncentiveCoordinationDescription', label: "If there are incentives, how will IC's coordinate incentive distribution?" },
        { name: (item) => JsxHelper.YesNo(item.IccoordinatorBilingualRequired), label: 'Does IC Coordinator Need to be Bilingual?' },
        { name: 'BareOrClientSurvey', label: 'BARE Provides Survey or Client Provides Survey' },
        { name: (item) => JsxHelper.YesNo(item.IncentiveProvidedByBare), label: 'Incentive Provided by BARE?' },
        { name: 'MonitoringType', label: 'Online Monitoring or Online Reputation Management?' },
        { name: (item) => Array.isArray(item.PlatformsToMonitor) ? item.PlatformsToMonitor.join(', ') : (item.PlatformsToMonitor || ''), label: 'Media/Internet Platforms' },
        { name: 'FrequencyOfMonitoring', label: 'Frequency of Monitoring' },
        { name: (item) => <LookupTextLookupItemIdArray lookupId={20} valueArray={item.LanguagesToMonitor} />, label: 'Languages to Monitor' },
        { name: 'Keywords', label: 'Keywords' },
        { name: 'GoalOfProgram', label: 'Goal of the Program' },
        { name: (item) => Array.isArray(item.ScopeOfMonitoring) ? item.ScopeOfMonitoring.join(', ') : (item.ScopeOfMonitoring || ''), label: 'Scope of Monitoring' },
        { name: 'ClientGuidelines', label: 'Client Guidelines', width: TabListTableCellWidthEnum.TwoLines },
        { name: '-', label: 'B2B Approach' },
        { name: (item) => JsxHelper.YesNo(item.FictiosWebsiteCreationNeeded), label: 'Fictious Website Creation Needed' },
        { name: (item) => JsxHelper.YesNo(item.IsBusinessInformationRequired), label: 'Is Business Information Required' },
        { name: 'BusinessInformationDescription', label: 'If Yes, please describe' },
      ],
    },
    {
      tabName: 'Questionnaire',
      tabLabel: 'Questionnaire',
      icon: 'fa-solid fa-clipboard-question',
      data: [
        { name: 'NumAuditSurveys', label: 'No. of Audit Surveys (Area to audit)' },
        { name: 'ApproxNumQuestionsPerSurvey', label: 'Approx. No. of Questions per Survey' },
        { name: 'NumClosedQuestions', label: 'No. Closed Questions' },
        { name: 'NumOpenQuestions', label: 'No. Simple Text Questions' },
        { name: 'NumNarrativeQuestions', label: 'No. Narrative Questions' },
        { name: (item) => JsxHelper.YesNo(item.QuestionnaireProvided), label: 'Questionnaire Provided by Client?' },
        { name: (item) => JsxHelper.YesNo(item.CollaborationInDataSoftware), label: 'Will Collaboration be Used in Data Software?' },
        { name: 'Mspplatform', label: 'MSP Platform' },
        { name: (item) => JsxHelper.YesNo(item.GuidelinesProvided), label: 'Guidelines Provided by Client?' },
        { name: (item) => JsxHelper.YesNo(item.TranslationProvided), label: 'Translation of Questionnaire Provided by Client?' },
        { name: (item) => <LookupTextLookupItemIdArray lookupId={20} valueArray={item.RequiredLanguageCode} />, label: 'Required Language(s) Reporting' },
        { name: 'OtherDataCaptureMethod', label: 'Other Data Capture Method Description' },
        { name: 'TypeOfServiceRequested', label: 'Type of Service Requested' },
        { name: 'Regularity', label: 'Regularity' },
        { name: 'SpecificRequirements', label: 'Specific Requirements' },
        { name: 'TopIssues', label: 'Top Issues' },
      ],
    },
    {
      tabName: 'Demographics',
      tabLabel: 'Demographics',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'MinAge', label: 'Minimum Age' },
        { name: 'MaxAge', label: 'Maximum Age' },
        { name: (item) => <LookupText lookupId={17} value={item.GenderCode} />, label: 'Gender' },
        { name: (item) => <LookupText lookupId={18} value={item.MaritalStatusCode} />, label: 'Marital Status' },
        { name: (item) => JsxHelper.YesNo(item.IsChildRequiredForVisit), label: 'Child Required for Visit' },
        { name: (item) => <LookupText lookupId={61} value={item.EvaluationType} />, label: 'Description of Additional Demographic Requirements' },
        { name: 'OtherDemographicRequirements', label: 'Other Demographic Requirements' },
      ],
    },
    {
      tabName: 'Purchase',
      tabLabel: 'Purchase',
      icon: 'fa-solid fa-cart-shopping',
      data: [
        { name: (item) => JsxHelper.YesNo(item.PurchaseReqd), label: 'Purchase Required?' },
        { name: (item) => JsxHelper.YesNo(item.ReceiptReqd), label: 'Receipt Required?' },
        { name: (item) => <ShowNameComponent serviceFunction={CurrencyService.GetCurrencyNameById} id={item.PurchaseAmtCurId} />, label: 'Purchase Amount Currency' },
        { name: 'PurchaseAmt', label: 'Minimum Purchase Amount' },
        { name: 'MaxPurchaseAmt', label: 'Maximum Purchase Amount' },
        { name: 'PurchaseDesc', label: 'Item Required to Be Purchased', width: TabListTableCellWidthEnum.TwoLines },
        { name: (item) => JsxHelper.YesNo(item.PurchaseReimbursed), label: 'Purchase Reimbursed by Client?' },
        { name: (item) => JsxHelper.YesNo(item.PurchaseIncluded), label: 'Purchase NOT Reimbursed by BARE or Client?' },
        { name: (item) => JsxHelper.YesNo(item.PurchaseReturned), label: 'Required Purchase to be Returned?' },
        { name: (item) => JsxHelper.YesNo(item.PhonePurchaseRequired), label: 'Over the Phone Purchase Required?' },
        { name: (item) => JsxHelper.YesNo(item.ReimbursementRequired), label: 'Reimbursement Requirement?' },
      ],
    },
    {
      tabName: 'Validation',
      tabLabel: 'Validation',
      icon: 'fa-solid fa-camera',
      data: [
        { name: 'NumPhotographsReqd', label: 'Number of Photographs Required' },
        { name: (item) => JsxHelper.YesNo(item.PhotosReqd), label: 'Storefront Photo Required?' },
        { name: (item) => JsxHelper.YesNo(item.LeftRightLocReqd), label: 'Left and Right of Storefront Photos Required?' },
        { name: 'OtherPhotosDesc', label: 'Describe other Photographs Required', width: TabListTableCellWidthEnum.TwoLines },
        { name: (item) => JsxHelper.YesNo(item.SoundRecordingReqd), label: 'Sound Recording Required?' },
        { name: (item) => <LookupText lookupId={35} value={item.OtherValidationReqd} />, label: 'Other Validation' },
        { name: (item) => JsxHelper.YesNo(item.VideoValidationReqd), label: 'Video Validation Required?' },
        { name: 'NumScreenshotsRequired', label: 'Number of Screenshots Required' },
        { name: (item) => Array.isArray(item.SmsweChatWhatsappScreenshots) ? item.SmsweChatWhatsappScreenshots.join(', ') : (item.SmsweChatWhatsappScreenshots || ''), label: 'SMS, We Chat, or WhatsApp Screenshots Required?' },
        { name: (item) => JsxHelper.YesNo(item.VoicemailTimeStampScreenshot), label: 'Voicemail Time Stamp Screenshot' },
        { name: 'NumCallAttemptsPerEval', label: 'No. of Call Attempts per Evaluation' },
      ],
    },
    {
      tabName: 'Reporting',
      tabLabel: 'Reporting',
      icon: 'fa-solid fa-file-lines',
      data: [
        { name: (item) => Array.isArray(item.ReportingRequirements) ? item.ReportingRequirements.join(', ') : (item.ReportingRequirements || ''), label: 'Reporting Requirements' },
        { name: 'DetailedReportingRequirements', label: 'Detailed Reporting Requirements', width: TabListTableCellWidthEnum.TwoLines },
        { name: 'CustomExportsRequired', label: 'Custom Exports Required?' },
        { name: (item) => JsxHelper.YesNo(item.Apirequirement), label: 'API Requirement?' },
        { name: 'BitoolSelection', label: 'BI Tool Selection' },
        { name: 'FrequencyOfUpdate', label: 'Frequency of Update' },
        { name: 'DataSourcesOtherThanMs', label: 'Data Sources Other Than MS' },
        { name: 'MainMetrics', label: 'Main Metrics' },
        { name: (item) => JsxHelper.YesNo(item.ComparisonsByWaveAndRegion), label: 'Comparisons by Wave and Region' },
        { name: (item) => Array.isArray(item.AdditionalVisualizations) ? item.AdditionalVisualizations.join(', ') : (item.AdditionalVisualizations || ''), label: 'Additional Visualizations' },
        { name: 'InsightHighlights', label: 'Insight Highlights' },
        { name: (item) => Array.isArray(item.InteractiveFeatures) ? item.InteractiveFeatures.join(', ') : (item.InteractiveFeatures || ''), label: 'Interactive Features' },
        { name: 'SubDashboards', label: 'Sub Dashboards' },
        { name: 'UserAccess', label: 'User Access' },
      ],
    },
    {
      tabName: 'PhoneCalls',
      tabLabel: 'Phone Calls',
      icon: 'fa-solid fa-phone',
      data: [
        { name: (item) => JsxHelper.YesNo(item.PhoneCallsRequired), label: 'Are Phone Calls Required?' },
        { name: 'CallFlowDescription', label: 'Call Flow Description' },
        { name: (item) => JsxHelper.YesNo(item.CallerIdNeeded), label: 'Caller ID Needed?' },
        { name: 'PhoneCallDescription', label: 'Description of Calls', width: TabListTableCellWidthEnum.TwoLines },
        { name: 'NumCallsRecorded', label: 'No. of Recorded Calls per Evaluation' },
        { name: 'AvgVocazillaCallLength', label: 'Avg. Recorded Call Length (min) per Call' },
        { name: 'FollowUpPeriodExpected', label: 'Wait for Follow-up Period Expected' },
        { name: 'NumCallsNonRecorded', label: 'No. of Non-Recorded Calls per Evaluation' },
        { name: 'AvgNonRecordedCallLength', label: 'Avg. Non-Recorded Call Length (min) per Call' },
      ],
    },
    {
      tabName: 'BusinessIntelligence',
      tabLabel: 'Business Intelligence',
      icon: 'fa-solid fa-chart-bar',
      data: [
        { name: '-', label: 'BI Analysis' },
        { name: 'Template', label: 'Template' },
        { name: 'Output', label: 'Output' },
        { name: (item) => JsxHelper.YesNo(item.NumVisualizations), label: 'Number of Visualizations (slides)' },
        { name: 'ActionableInsights', label: 'Actionable Insights' },
        { name: 'Kpianalysis', label: 'KPI Analysis' },
        { name: 'BenchmarkingAgainstIndustry', label: 'Benchmarking Against Industry' },
        { name: 'SourcesTypeOfPrograms', label: 'Sources / Type of Programs' },
        { name: 'ComparisonsByWave', label: 'Comparisons by Wave' },
        { name: 'ComparisonsByRegion', label: 'Comparisons by Region' },
        { name: 'BiconsultancyDescription', label: 'BI Consultancy Description' },
        { name: '-', label: 'BI Analysis' },
        { name: 'NumOpenEndsAnalyzed', label: 'Number of Open Ends to Be Analyzed' },
        { name: 'NumEvalPerCycle', label: 'Number of Evaluations per Cycle' },
        { name: 'Summarization', label: 'Summarization?' },
        { name: 'TopicModeling', label: 'Topic Modeling?' },
        { name: 'EmotionAnalytics', label: 'Emotion Analytics?' },
        { name: 'AspectBasedSentimentAnalysis', label: 'Aspect-Based Sentiment Analysis?' },
        { name: 'Mspplatform', label: 'MSP Platform' },
        { name: 'DeliveryPlatform', label: 'Delivery Platform' },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
